import { useTranslation } from 'react-i18next';

interface Props {
  description: string | null;
}

/**
 * Wo diese Wohnung im Haus liegt und wie man hineinkommt. Steht unter „Ankommen“ direkt nach der
 * Adresse — die Codes dazu trägt der Jetzt-Bereich.
 *
 * Vorher stand die Etagenliste ALLER Apartments in einem gemeinsamen Anfahrschritt — der Gast
 * musste sich selbst darin suchen und wusste nicht sicher, welche Wohnung seine ist.
 *
 * Nicht zeitgesperrt: hier steht kein Code, nur wo es langgeht.
 */
export function ApartmentDescriptionBlock({ description }: Props) {
  const { t } = useTranslation();
  if (!description?.trim()) return null;

  // Die Marke in Sealwax (einzige erlaubte Ausnahme im Gastportal): das ist die Zeile, die der
  // Gast im Treppenhaus sucht; als graue Überschrift ging sie unter.
  return (
    <section className="bg-bg-elev border-line rounded-guest-card shadow-guest-card space-y-1.5 border p-4">
      <h3 className="text-sealwax font-mono text-[10px] font-semibold uppercase tracking-[0.16em]">
        {t('stations.stay.apartmentDescription.title')}
      </h3>
      <p className="text-fg whitespace-pre-wrap text-[15px] leading-relaxed">{description}</p>
    </section>
  );
}
